import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface EnvironmentalAssessmentResult {
  id: string;
  assessmentType: string;
  scores: {
    overall: number;
    rawScore: number;
    transformedScore: number;
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations: string[];
  };
  createdAt: string;
}

const EnvironmentalAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const assessmentResult = location.state?.assessmentResult as EnvironmentalAssessmentResult;
  
  if (!assessmentResult || !assessmentResult.scores || !assessmentResult.results) {

    navigate('/panel/learn/environmental-resources');
    return null;
  }

  try {
    const config = createAssessmentConfig(assessmentResult, {
      assessmentType: 'environmental',
      assessmentName: 'environmental-assessment',
      assessmentDisplayName: 'ENVIRONMENTAL ASSESSMENT',
      redoRoute: '/panel/learn/environmental-assessment',
      completeRoute: '/panel/insights',
      scoreLabel: 'Environmental Quality of Life Score',
      subtitleMapping: {
        High: 'Good Environmental Quality of Life',
        Moderate: 'Moderate Environmental Quality of Life',
        Low: 'Poor Environmental Quality of Life'
      },
      visualMessage: "You've completed the assessment!",
      resultsTitle: "Here's your environmental quality of life analysis"
    });
    
    return <AssessmentCompletionTemplate config={config} />;
  } catch (error) {

    navigate('/panel/learn/environmental-resources');
    return null;
  }
};

export default EnvironmentalAssessmentCompletionPage;



